/* eslint-disable no-unused-vars */
import React from 'react';
import { Chart } from 'react-google-charts';
import './style.scss';

import PropTypes from 'prop-types';

import { ReactComponent as Get } from 'src/assets/icons/get.svg';
import { ReactComponent as Doc } from 'src/assets/icons/dashboard/doc.svg';
import { ReactComponent as Mouse } from 'src/assets/icons/dashboard/mouse.svg';
import { ReactComponent as Scroll } from 'src/assets/icons/dashboard/scroll.svg';
import { ReactComponent as Info } from 'src/assets/icons/dashboard/info.svg';
import { ReactComponent as ChartIcon } from 'src/assets/icons/dashboard/chart.svg';
import { ReactComponent as List } from 'src/assets/icons/dashboard/list.svg';

export default function DashboardItem({
  type,
  title,
  desc,
  color,
  info,
  data,
  options,
  width,
  height,
}) {
  return (
    <div className={`itemDashboard ${type}`} style={{ width, height }}>
      <div className={'itemBody'}>
        <div className={'top'}>
          {
            {
              pizza: (
                <div className={'chartWrapper'}>
                  <Chart
                    chartType="PieChart"
                    data={data}
                    options={{
                      chartArea: { width: '100%', height: '100%' },
                      ...options,
                    }}
                    width="auto"
                    height="100%"
                  />
                </div>
              ),
              barra: (
                <div className={'chartWrapper'}>
                  <Chart
                    chartType="Bar"
                    data={data}
                    options={{
                      chartArea: { width: '100%', height: '100%' },
                      ...options,
                    }}
                    width="100%"
                    height="auto"
                  />
                </div>
              ),
              mapa: (
                <div className={'chartWrapper'}>
                  <Chart
                    chartType="OrgChart"
                    data={data}
                    options={options}
                    width="100%"
                    height="auto"
                  />
                </div>
              ),
              info: (
                <div className={'dashboardIcon'}>
                  <Doc className="svgIcon" />
                </div>
              ),
              linha: (
                <div className={'chartWrapper'}>
                  <Chart
                    chartType="LineChart"
                    data={data}
                    options={options}
                    width="100%"
                    height="auto"
                  />
                </div>
              ),
              lista: (
                <div className={'listaWrapper'}>
                  <span />
                  <div className="scroll">
                    {data?.map((item, id) => (
                      <div key={id}>
                        <h5>{item.left}</h5>
                        <span />
                        <h4>{item.right}</h4>
                      </div>
                    ))}
                  </div>
                  <div className="ico">
                    <Mouse className="svgIcon icon2" />
                    <Scroll className="svgIcon" />
                  </div>
                </div>
              ),
            }[type]
          }

          {type !== 'barra' && (
            <span>
              <h1 style={{ color }}>{title}</h1>
              <h2>{desc}</h2>
            </span>
          )}
        </div>

        <div className={'chartInfo'} style={{ background: color }}>
          <p>{info}</p>
          {
            {
              info: <Info className="svgIcon" />,
              pizza: <ChartIcon className="svgIcon" />,
              barra: <ChartIcon className="svgIcon" />,
              linha: <ChartIcon className="svgIcon" />,
              mapa: <ChartIcon className="svgIcon" />,
              lista: <List className="svgIcon" />,
            }[type]
          }
        </div>
      </div>
    </div>
  );
}

DashboardItem.propTypes = {
  type: PropTypes.string,
  title: PropTypes.func,
  desc: PropTypes.func,
  color: PropTypes.func,
  info: PropTypes.string,
  data: PropTypes.array,
  options: PropTypes.object,
  width: PropTypes.func,
  height: PropTypes.func,
};
